import React, { useEffect, useRef, useState } from "react";

/**
 * Ảnh responsive dùng WebP + srcset (400 / 800 / 1600px), fade-in mượt khi tải xong.
 */
export default function Img({ src, alt = "", sizes, className = "", loading = "lazy", width = 1600, height = 1067, ...rest }) {
  const ref = useRef(null);
  const [loaded, setLoaded] = useState(loading === "eager");

  useEffect(() => {
    const img = ref.current;
    setLoaded(loading === "eager" || !!(img && img.complete && img.naturalWidth > 0));
  }, [src, loading]);

  const markLoaded = () => setLoaded(true);
  const cls = `ah-img${loaded ? " ah-img-loaded" : ""} ${className}`;

  if (!src || !src.endsWith(".webp")) {
    return (
      <img
        ref={ref}
        src={src}
        alt={alt}
        width={width}
        height={height}
        className={cls}
        loading={loading}
        suppressHydrationWarning
        onLoad={markLoaded}
        onError={markLoaded}
        {...rest}
      />
    );
  }
  const base = src.slice(0, -5);
  const srcSet = `${base}-400.webp 400w, ${base}-800.webp 800w, ${src} 1600w`;

  return (
    <img
      ref={ref}
      src={src}
      srcSet={srcSet}
      sizes={sizes || "(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"}
      alt={alt}
      width={width}
      height={height}
      loading={loading}
      decoding="async"
      suppressHydrationWarning
      onLoad={markLoaded}
      onError={markLoaded}
      className={cls}
      {...rest}
    />
  );
}
